import styled, { css, keyframes } from 'styled-components';
import { IFloating, ILoading, ISender, IText } from './types';

export const Container = styled.div<IFloating>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  position: relative;

  ${({ floating }) => {
    if (floating) {
      return css`
        padding: 0 10px;
        height: 100%;
        z-index: 1001;
        justify-content: space-between;
        overflow-y: auto;
      `;
    }
  }}
`;

export const WrapperMenssages = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 20px;
`;
export const WrapperLine = styled.div<ISender>`
  display: flex;
  width: 100%;
  flex: 1;
  justify-content: ${({ typeSender }) =>
    typeSender === 'user' ? 'end' : 'start'};
`;
export const WrapperMessage = styled.div<ISender & IFloating>`
  display: flex;

  gap: 10px;

  ${({ typeSender }) => {
    if (typeSender === 'greenfy AI') {
      return css`
        flex-direction: row-reverse;
      `;
    }
  }}
  ${({ floating }) => {
    if (floating) {
      return css`
        width: 100%;

        max-width: 90% !important;
      `;
    }

    return css`
      max-width: 70%;
    `;
  }}
`;

export const WrapperMessageText = styled.div<ISender & IFloating>`
  display: flex;
  padding: 20px;
  width: 100%;
  border-radius: 30px;
  flex: 1;

  ${({ floating }) => {
    if (floating) {
      return css`
        padding: 15px;
      `;
    }
  }}

  ${({ typeSender, floating }) => {
    if (typeSender === 'user' && floating) {
      return css`
        border-top-right-radius: 0px;
        background: #f4f4f4;
        justify-content: end;
      `;
    }
    if (typeSender === 'user') {
      return css`
        border-top-right-radius: 0px;
        background: #ffffff;
        justify-content: end;
      `;
    }
    return css`
      border-top-left-radius: 0px;
      background: rgba(0, 255, 191, 0.1);
      display: flex;
    `;
  }}
`;

export const WrapperMessageLink = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const MessageText = styled.p<IText>`
  color: ${({ white }) => (white ? '#fff' : '#1e1e1e')};
  font-size: 16px;
  font-weight: 500;
  margin: 0;
`;
export const WrapperProfile = styled.div<ISender & IFloating>`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 75px;
  width: 75px;
  border-radius: 100px;

  ${({ floating }) => {
    if (floating) {
      return css`
        height: 50px;
        width: 50px;
      `;
    }
  }}
  ${({ typeSender }) => {
    if (typeSender === 'user') {
      return css`
        background: #828282;
      `;
    }
    return css`
      background: #005f47;
    `;
  }}
`;

export const Form = styled.form<IFloating>`
  width: 100%;

  position: sticky;
  bottom: 0;
  padding: 20px 0 30px;
  background: ${({ floating }) => (floating ? '#fff' : '#efefef')};
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ floating }) => {
    if (floating) {
      return css`
        position: -ms-page;
        bottom: 0;
        flex: none;
        padding-top: 10px;
        padding-bottom: 10px;
      `;
    }
  }}
`;

const borderAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

export const WrapperInput = styled.div`
  background: #efffdf;
  padding: 30px;
  border-radius: 30px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex: 1;
  align-items: self-start;
  gap: 10px;
  max-width: 900px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 30px;
    padding: 3px;
    background: linear-gradient(90deg, #005f47, rgb(255, 161, 161), #005f47);
    background-size: 300% 300%;
    animation: ${borderAnimation} 4s infinite linear;
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }
`;

export const Input = styled.textarea`
  color: #1b1b1b;
  font-weight: 800;
  font-size: 16px;
  outline: none;
  border: none;
  width: 100%;
  background: none;
  resize: none;
  &::placeholder {
    color: #616161;
  }
`;

export const WrapperIconSend = styled.a<ILoading>`
  background: ${({ isLoading }) => (isLoading ? '#616161' : '#005f47')};
  padding: 14px;
  border-radius: 1000px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LinkToRoute = styled.a`
  border-radius: 30px;
  background: #005f47;
  padding: 10px 20px;
  text-decoration: none;
  color: #fff;
  font-weight: 700;
  width: max-content;
`;
